/**
 * A tab that exists in the design but has not been built yet.
 */
import { ComingSoonCard } from './ComingSoonCard';

export interface ReservedTabProps {
  tab: string;
}

export function ReservedTab({ tab }: ReservedTabProps) {
  return (
    <ComingSoonCard title={tab}>
      This tab lands in a follow-up. The Details tab is live now.
    </ComingSoonCard>
  );
}
